import * as React from "react";

function SvgCwdChatResizeGrip(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 9" fill="none" stroke="currentColor" strokeWidth={1.25} strokeLinecap="round" {...props}><path d="M8 1v7H1" /></svg>;
}

export default SvgCwdChatResizeGrip;